module.exports = __webpack_public_path__ + "img/borderCircularAndRightWhite.f0e62d08.svg";